import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BuildingApiService } from '../services/api/building-api.service';
import { AuthApiService } from '../services/api/auth-api.service';
import { IWebsiteBuilder } from '../types/api-response/auth/website-builder';
import { Permission } from '../types/api-response/auth/permission';
import { AccountPermissionsService } from '../services/account-permissions.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AnnouncementWebsitesResolver implements Resolve<Observable<IWebsiteBuilder[]>> {

    /**
     * PM user Permission for corporations
     */
    private corporationPermission: { [key: number]: Set<Permission> };

    /**
     * Permissions to filter sites list
     */
    private permissionsToCheck = [Permission.create, Permission.update];

    constructor(
        private buildingApi: BuildingApiService,
        private authApi: AuthApiService,
        private account: AccountPermissionsService,
    ) {
        this.corporationPermission = this.account.getCorporationServicePermissions('announcements');
    }

    /**
     * Resolves number of resident patches
     *
     * for building ID
     */
    resolve(route: ActivatedRouteSnapshot): Observable<IWebsiteBuilder[]> {
        return this.authApi.getWebsiteBuilderList({status: true, announcements_status: true, 'per-page': 10000}).pipe(
            map(result => result.entities
                .filter(website => this.filterSitesByRolePermissions(website))
            )
        );
    }

    /**
     * Checks permission for corporation number ID
     */
    private filterSitesByRolePermissions(website: IWebsiteBuilder): boolean {
        if (this.account.isUserAdmin()) {
            return true;
        }

        return this.permissionsToCheck.reduce((isPevAllowed, permission) =>
            isPevAllowed && this.corporationPermission[website.corporationNumberId].has(permission), true);
    }
}



// WEBPACK FOOTER //
// /app/src/app/resolvers/announcement-websites.resolver.ts